import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const payRateByLocationResponse = z.array(
  z.object({
    company_name: z.string(),
    position_type: z.string(),
    shift_date: z.string(),
    avg_pay_rate_current_period: z.number(),
    avg_pay_rate_previous_period: z.number().nullable().optional(),
    change_in_pay_rate_current_period: z.number().nullable().optional(),
    period_change_in_fill_rate_current_period: z.number().nullable().optional(),
    fill_rate_current_period: z.number(),
    fill_rate_previous_period: z.number().nullable().optional(),
  })
)

export type PayRateByLocation = z.infer<typeof payRateByLocationResponse>

export async function getPayRateByLocation(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/pay_rate_by_location', data, { signal })
    .then((response) => response.data)
    .then(payRateByLocationResponse.parse)
}

export async function getPayRateByLocationCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/pay_rate_by_location/csv', data, { signal })
    .then((response) => response.data)
}
